import _ from "lodash";

import { put, take, race } from "redux-saga/effects";

import { confirmActions, type ConfirmState } from "./Confirm.slice";

export function* showConfirmDialogAndWaitForAction(payload: ConfirmState) {
  yield put(confirmActions.show(payload));
  const { yes, no, cancel } = yield race({
    yes: take(confirmActions.yes),
    no: take(confirmActions.no),
    cancel: take(confirmActions.cancel)
  });
  return {
    yes,
    no,
    cancel
  };
}

export default function* sagaWatcher() {}
